export default "__VITE_ASSET__CGwcOLDv__"